import { render } from "./AtomStar.vue?vue&type=template&id=38325e92&scoped=true"
import script from "./AtomStar.vue?vue&type=script&lang=js"
export * from "./AtomStar.vue?vue&type=script&lang=js"

import "./AtomStar.vue?vue&type=style&index=0&id=38325e92&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38325e92"]])

export default __exports__